import { d as debounce } from './debounce-CFtxQv9K.js';

class ScrollMore extends HTMLElement {
  container;
  scrollHandler;

  connectedCallback() {
    this.container = this.closest(this.dataset.container);
    if (!this.container) return;

    this.toggleButtonVisibility();

    // Listen for click
    this.addEventListener('click', () => {
      this.container.scrollTo({
        top: this.container.scrollHeight,
        behavior: 'smooth',
      });
    });

    // Check overflow on resize
    window.addEventListener(
      'resize',
      debounce(() => {
        this.toggleButtonVisibility();
      }, 250)
    );

    setInterval(() => {
      this.toggleButtonVisibility();
    }, 200);

    // Store the debounced handler
    this.scrollHandler = debounce(() => {
      if (!this.container) return;
      if (!this.classList.contains('hidden')) this.toggleButtonVisibility();
    }, 100);

    this.container.addEventListener('scroll', this.scrollHandler);
  }

  disconnectedCallback() {
    if (this.scrollHandler) {
      this.container?.removeEventListener('scroll', this.scrollHandler);
    }
  }

  /**
   * Show the button if the container has overflowed and the user has scrolled
   * @returns {boolean}
   */
  toggleButtonVisibility() {
    const scrollDifference = this.container.scrollHeight - this.container.clientHeight;
    const hasScrolled = this.container.scrollTop > 0;

    scrollDifference > 50 && !hasScrolled ? this.show() : this.hide();
  }

  /**
   * Show the scroll more button
   */
  show() {
    this.classList.remove('opacity-0', 'pointer-events-none');
  }

  /**
   * Hide the scroll more button
   */
  hide() {
    this.classList.add('opacity-0', 'pointer-events-none');
  }
}

customElements.define('scroll-more', ScrollMore);
